"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCoilType = setCoilType;
exports.setToolMode = setToolMode;
exports.calculateCoil = calculateCoil;
exports.setProperties = setProperties;
exports.setPropertiesFromFile = setPropertiesFromFile;
exports.setPropertiesCoilproDownloadSelector = setPropertiesCoilproDownloadSelector;
function setCoilType(coilType) {
    return {
        type: "coil-pro-tool/SET-COIL-TYPE",
        coilType: coilType
    };
}
function setToolMode(mode) {
    return {
        type: "coil-pro-tool/SET-TOOL-MODE",
        mode: mode
    };
}
function calculateCoil(screen) {
    return {
        type: "coil-pro-tool/CALCULATE-COIL",
        payload: screen
    };
}
function setProperties(pvs) {
    return {
        type: "coil-pro-tool/SET-PROPERTIES",
        payload: { pvs }
    };
}
function setPropertiesFromFile(file) {
    return {
        type: "coil-pro-tool/SET-PROPERTIES-FROM-FILE",
        payload: { coilType: file.coilType, pvses: file.pvses }
    };
}
function setPropertiesCoilproDownloadSelector(popupState) {
    return {
        type: "popup-component/SET-PROPERTIES-COILPRO-DOWNLOAD-SELECTOR",
        payload: popupState
    };
}
//# sourceMappingURL=actions.js.map